<template>
  <v-dialog v-model="dialog" width="600" scrollable>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>

    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Quantità e Colori
        <v-spacer />
        <v-btn icon @click="chiudi"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="" style="min-height: 200px">
        <v-row class="mb-1">
          <v-col cols="12">
            <span style="font-size: 20px"> {{ nome[0] }}</span>
            <br />
            <span style="font-size: 12px"> {{ nome[1] }}</span>
          </v-col>
        </v-row>
        <v-row v-if="loading_init" justify="center" class="py-8">
          <v-progress-circular indeterminate color="primary" />
        </v-row>

        <template v-else>
          <!-- Con specie: raggruppato per serie -->
          <template v-if="prodotto && prodotto.specie">
            <div
              v-for="serie in colori_per_serie"
              :key="serie.nome_serie || 'no-serie'"
            >
              <div v-if="serie.nome_serie" class="caption grey--text mt-2 mb-1">
                {{ serie.nome_serie }}
              </div>
              <v-row no-gutters class="flex-wrap mb-2">
                <v-menu
                  v-for="colore in serie.colori"
                  :key="colore.id"
                  offset-y
                  bottom
                  max-width="200"
                  :close-on-content-click="false"
                  @input="(v) => on_menu_open(v, colore.id)"
                >
                  <template v-slot:activator="{ on: men_u }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tip }">
                        <v-badge
                          color="green"
                          :value="colore._qta > 0"
                          :content="colore._qta"
                          overlap
                          bordered
                          offset-x="20"
                          offset-y="20"
                        >
                          <v-avatar
                            v-on="{ ...tip, ...men_u }"
                            style="cursor: pointer"
                            class="mr-2 mb-2"
                            size="70"
                          >
                            <v-img :src="color_img(colore)" :alt="colore.nome">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    :width="2"
                                    color="primary"
                                  />
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </v-badge>
                      </template>
                      <span class="text-capitalize">{{ colore.nome }}</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-text class="mt-n2">
                      <v-row no-gutters class="primary--text"
                        >{{ colore.nome }}<v-spacer
                      /></v-row>
                      <v-row no-gutters style="font-size: 12px" class="mb-2"
                        >Specifica quantità:</v-row
                      >
                      <v-text-field
                        :ref="'qty_' + colore.id"
                        v-model.number="colore._qta"
                        maxlength="3"
                        dense
                        hide-details
                        outlined
                        prepend-icon="mdi-minus"
                        append-outer-icon="mdi-plus"
                        @click:prepend="colore._qta > 0 ? colore._qta-- : null"
                        @click:append-outer="colore._qta++"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-row>
            </div>
          </template>

          <!-- Senza specie: flat -->
          <v-row v-else-if="prodotto" no-gutters class="flex-wrap">
            <v-menu
              v-for="colore in colori"
              :key="colore.id"
              offset-y
              bottom
              max-width="200"
              :close-on-content-click="false"
              @input="(v) => on_menu_open(v, colore.id)"
            >
              <template v-slot:activator="{ on: men_u }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tip }">
                    <v-badge
                      color="green"
                      :value="colore._qta > 0"
                      :content="colore._qta"
                      overlap
                      bordered
                      offset-x="20"
                      offset-y="20"
                    >
                      <v-avatar
                        v-on="{ ...tip, ...men_u }"
                        style="cursor: pointer"
                        class="mr-2 mb-2"
                        size="70"
                      >
                        <v-img :src="color_img(colore)" :alt="colore.nome">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                :width="2"
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-badge>
                  </template>
                  <span class="text-capitalize">{{ colore.nome }}</span>
                </v-tooltip>
              </template>
              <v-card>
                <v-card-text class="mt-n2">
                  <v-row no-gutters class="primary--text"
                    >{{ colore.nome }}<v-spacer
                  /></v-row>
                  <div v-if="colore.nome_serie" class="caption grey--text mb-1">
                    {{ colore.nome_serie }}
                  </div>
                  <v-row no-gutters style="font-size: 12px" class="mb-2"
                    >Specifica quantità:</v-row
                  >
                  <v-text-field
                    :ref="'qty_' + colore.id"
                    v-model.number="colore._qta"
                    maxlength="3"
                    dense
                    hide-details
                    outlined
                    prepend-icon="mdi-minus"
                    append-outer-icon="mdi-plus"
                    @click:prepend="colore._qta > 0 ? colore._qta-- : null"
                    @click:append-outer="colore._qta++"
                  />
                </v-card-text>
              </v-card>
            </v-menu>
          </v-row>

          <v-text-field
            v-model="commento"
            label="Note articolo"
            outlined
            dense
            hide-details
            class="mt-4"
          />
        </template>

        <v-alert v-if="error" type="error" dense text class="mt-3">
          {{ error }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="chiudi">Annulla</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading_init"
          @click="salva"
        >
          Salva
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PrenotazioneModificaColoriDialog",

  props: {
    idPrenotazione: { type: String, required: true },
    art: { type: Object, required: true },
  },

  data() {
    return {
      dialog: false,
      colori: [],
      commento: "",
      loading_init: false,
      loading: false,
      error: null,
    };
  },

  computed: {
    prodotto() {
      return (
        (this.$store.getters.get_lista_prodotti_raw || []).find(
          (p) => p.id === this.art.art
        ) || null
      );
    },
    nome() {
      return this.prodotto.nome.split(" in ");
    },

    colori_per_serie() {
      const map = {};
      this.colori.forEach((c) => {
        const key = c._nome_serie || "";
        if (!map[key]) map[key] = { nome_serie: key, colori: [] };
        map[key].colori.push(c);
      });
      return Object.values(map).sort((a, b) => {
        if (!a.nome_serie) return -1;
        if (!b.nome_serie) return 1;
        return a.nome_serie.localeCompare(b.nome_serie);
      });
    },
  },

  watch: {
    dialog(val) {
      if (val) this.init();
    },
  },

  methods: {
    async init() {
      this.loading_init = true;
      this.error = null;
      try {
        const prodotto = this.prodotto;
        if (!prodotto) return;

        this.commento = this.art.commento || "";

        const qta_map = {};
        (this.art.colori || []).forEach((c) => {
          qta_map[c.id] = c.numero;
        });

        if (prodotto.specie) {
          const specie = this.$store.getters.get_specie_by_id(prodotto.specie);
          if (!specie) return;
          const colori_specie = await this.$store.dispatch(
            "fetch_colori_by_id",
            specie.colori
          );
          this.colori = colori_specie
            .filter(
              (c) =>
                prodotto.series?.includes(c.id_series?.[0]) ||
                (prodotto.series?.includes("000000") &&
                  (!c.id_series || c.id_series.length === 0))
            )
            .map((c) => {
              const id_s = c.id_series?.[0] ?? null;
              const serie_obj = id_s
                ? specie.series.find((s) => s.id === id_s)
                : null;
              return {
                ...c,
                _qta: qta_map[c.id] ?? 0,
                _nome_serie: serie_obj?.nome ?? "",
              };
            });
        } else {
          this.colori = (prodotto.colori ?? []).map((c) => ({
            ...c,
            _qta: qta_map[c.id] ?? 0,
          }));
        }
      } finally {
        this.loading_init = false;
      }
    },

    async salva() {
      this.loading = true;
      this.error = null;
      try {
        const qta_map = {};
        (this.art.colori || []).forEach((c) => {
          qta_map[c.id] = c.numero;
        });

        for (const colore of this.colori) {
          const qta_prima = qta_map[colore.id] ?? 0;
          if (colore._qta > 0 && colore._qta !== qta_prima) {
            await this.$store.dispatch("prenotazioni/aggiorna_colore", {
              id: this.idPrenotazione,
              id_prodotto: this.prodotto.id,
              id_colore: colore.id,
              qta: colore._qta,
              nome_serie: colore._nome_serie ?? colore.nome_serie ?? "",
            });
          } else if (colore._qta === 0 && qta_prima > 0) {
            await this.$store.dispatch("prenotazioni/elimina_colore", {
              id: this.idPrenotazione,
              id_prodotto: this.prodotto.id,
              id_colore: colore.id,
            });
          }
        }
        if (this.commento !== (this.art.commento || "")) {
          await this.$store.dispatch(
            "prenotazioni/aggiorna_commento_articolo",
            {
              id: this.idPrenotazione,
              id_prodotto: this.prodotto.id,
              commento: this.commento,
            }
          );
        }
        this.$emit("aggiornata");
        this.chiudi();
      } catch {
        this.error = "Errore durante il salvataggio. Riprova.";
      } finally {
        this.loading = false;
      }
    },

    on_menu_open(opened, colore_id) {
      if (!opened) return;
      setTimeout(() => {
        const ref = this.$refs["qty_" + colore_id];
        const field = Array.isArray(ref) ? ref[0] : ref;
        const input = field?.$el?.querySelector("input");
        if (input) {
          input.focus();
          input.select();
        }
      }, 100);
    },

    color_img(colore) {
      if (this.prodotto?.specie) {
        return process.env.VUE_APP_API_ROOT + "/specie/img_colore/" + colore.id;
      }
      return (
        process.env.VUE_APP_API_ROOT +
        "/prodotto/" +
        this.prodotto.id +
        "/img_colore/" +
        colore.id
      );
    },

    chiudi() {
      this.dialog = false;
      this.colori = [];
      this.commento = "";
      this.error = null;
    },
  },
};
</script>
